'use client';
import { revalidateGetEquipment } from 'services/equipment/actions';
import ErrorMessage from 'components/error-message';

export const MyEquipmentErrorMessage = () => {
  const handleOnRetry = async () => {
    await revalidateGetEquipment();
  };
  return (
    <ErrorMessage
      retryButtonLabel="RETRY"
      errorMessage="API_FAILURE_RETRY"
      onRetry={handleOnRetry}
    />
  );
};
